module.exports = __webpack_public_path__ + "element-icons.woff?535877f";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 449
// module chunks = 9